import { PropsWithChildren } from "react";

const Card = ({
  children,
  className = "",
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div
      className={`border border-card-border bg-white bg-opacity-[0.04] px-8 flex items-center ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
